
import { Video, FileText, FileAudio, Link2, File, BookOpen } from "lucide-react";

export const contentTypeOptions = [
  { value: "video", label: "Video", icon: Video },
  { value: "pdf", label: "PDF Document", icon: FileText },
  { value: "slides", label: "Slides", icon: FileText },
  { value: "audio", label: "Audio", icon: FileAudio },
  { value: "link", label: "External Link", icon: Link2 },
  { value: "required_reading", label: "Required Reading", icon: BookOpen },
  { value: "recommended_reading", label: "Recommended Reading", icon: BookOpen },
  { value: "other", label: "Other Resource", icon: File },
];

export const getContentTypeIcon = (contentType: string) => {
  const type = contentTypeOptions.find(option => option.value === contentType);
  if (!type) return File;
  return type.icon;
};

export const getContentTypeName = (contentType: string) => {
  const type = contentTypeOptions.find(option => option.value === contentType);
  return type ? type.label : contentType;
};
